import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b23f875e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-wrapper" }
const _hoisted_2 = { class: "main init-main" }

import { computed, ref } from 'vue'
import notFoundPage from './errorBodyComponent/notFound.vue'
import bannedPage from './errorBodyComponent/banned.vue'
import privatePage from './errorBodyComponent/private.vue'

import usePreference from '@teams/common/hooks/usePreference'
import TeamHead from '@/components/teamHead/Index.vue'
import { useTeamHead } from '@/components/teamHead'
import { useError } from './useError'
import useViewConfig from '@/hooks/useViewConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

_useCssVars(_ctx => ({
  "6252adc8": (_unref(defaultBackgroundUrl))
}))

const preference = usePreference()
const defaultBackgroundUrl = computed(
  () => `url(${preference.current.theme.styles['group-head-background-img']})`
)
const teamHeadRef = ref()
const teamHeadRefPropsForComponent = ref({
  openDrawer() {
    teamHeadRef.value?.openDrawer?.()
  },
  setTeamListToolTipShow(value: boolean) {
    teamHeadRef.value?.setTeamListToolTipShow?.(value)
  }
})
const { pageType, isLogin } = useError()
const { shouldStickyGroupPanel } = useViewConfig()
const teamHead = useTeamHead({
  showTeamMemberEntry: computed(() => {
    return false
  }),
  isVisitor: computed(() => {
    return true
  }),
  isLogin: isLogin,
  stickyGroupPanel: computed(() => shouldStickyGroupPanel.value),
  hiddenTeamSpace: computed(() => true),
  hiddenTeamMember: computed(() => true),
  hiddenShareBtn: computed(() => true),
  hiddenMessageAlert: computed(() => true),
  isEase: computed(() => preference.current.layout.isEase === 'true'),
  showLoginBtn: computed(() => false),
  showSpaceEnterGuide: computed(() => false)
})
const renderComponent = computed(() => {
  switch (pageType.value) {
    case 'notFoundSpace': {
      return notFoundPage
    }
    case 'bannedSpace': {
      return bannedPage
    }
    case 'privateSpace': {
      return privatePage
    }
    default: {
      return notFoundPage
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(TeamHead, _mergeProps(_unref(teamHead).props, {
        ref_key: "teamHeadRef",
        ref: teamHeadRef
      }), null, 16)
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(renderComponent)), {
          isLogin: _unref(isLogin),
          teamHeadRef: teamHeadRefPropsForComponent.value
        }, null, 8, ["isLogin", "teamHeadRef"]))
      ])
    ])
  ]))
}
}

})